import illustration from '../../../../shared/assets/empty-illustration.svg'
import { Link } from 'react-router-dom'
import React from 'react'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

interface TabCouponSitesStubProps {
  project?: string
}

export const TabCouponSitesStub = ({ project }: TabCouponSitesStubProps) => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[24px]'}>
          <div className={'flex w-full flex-col gap-[16px]'}>
            <div className={'flex flex-col items-center'}>
              <h2 className={'text-center text-[24px]'}>No data</h2>
              <p className={'text-center text-[15px] text-[#8E7CA7]'}>Why am I seeing this?</p>
            </div>
            <div
              className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
            >
              <p className={'text-focus-500'}>
                There are no ads for coupon and promo code aggregator sites for the{' '}
                <Link className={'text-default'} to={`/projects/${project}/keywords`}>
                  keywords
                </Link>{' '}
                selected in this project
              </p>
            </div>
          </div>
          <div className={'flex flex-col items-center justify-center gap-[8px]'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 A tip: try{' '}
              <Link className={'text-default'} to={`/projects/${project}/keywords`}>
                adding keywords
              </Link>{' '}
              like:
            </p>
            <div className={'flex flex-wrap justify-center gap-[4px] text-[13px] text-[#8E7CA7]'}>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>
                  your brand <span className={'font-semibold'}>coupons</span>
                </p>
              </div>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>
                  your brand <span className={'font-semibold'}>discount</span>
                </p>
              </div>
              <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
                <p className={'leading-none'}>
                  your brand <span className={'font-semibold'}>promo</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
